<template>
  <div class="alt-edit">
    <label>{{ labelText }}</label>
    <button @click="isShowAltSetter = true">編集</button>
    <portal v-if="isShowAltSetter" to="modal1">
      <edit-alt-popup
        :ids="ids"
        :defaultAttrs="attrs"
        :labelText="labelText"
        @close="isShowAltSetter = false"
      />
    </portal>
    <div class="alt-view">
      <p>{{ $utils.string.sanitizeDecode(attrs.alt) }}</p>
    </div>
  </div>
</template>

<script>
import EditAltPopup from '@/components/Content/Palette/EditPartDesign/Layouts/EditAltPopup'

export default {
  props: [
    'ids',
    'attrs',
  ],
  components: {
    EditAltPopup
  },
  computed: {
    labelText () {
      const partsContainer = this.$store.getters.findPartsContainer(this.ids.sectionId, this.ids.partsContainerId)
      if (!partsContainer) return null
      if (partsContainer.type === 'FollowButton' || partsContainer.type === 'Share') {
        return 'リンクテキスト'
      } else {
        return 'altテキスト'
      }
    },
  },
  data () {
    return {
      isShowAltSetter: false,
    }
  }
}
</script>

<style lang="scss" scoped>
.alt-edit {
  margin-top: 10px;
  font-size: 14px;
  width: 340px;
  button {
    margin-left: 10px;
    color: #3192e0;
    text-decoration: underline;
    user-select: none;
    cursor: pointer;
  }
  .alt-view {
    // 空の時も考慮する
    height: 30px;
    overflow: hidden;
    width: 100%;
    p {
      color: rgba($baseFontColor, 0.3);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
